import script from "./ShopAddition.vue?vue&type=script&lang=ts&setup=true"
export * from "./ShopAddition.vue?vue&type=script&lang=ts&setup=true"

import "./ShopAddition.vue?vue&type=style&index=0&id=a111f33e&lang=scss&scoped=true"

import exportComponent from "/apps/jenkins/workspace/client-prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a111f33e"]])

export default __exports__